import { Component, OnDestroy, OnInit } from '@angular/core';
import { MatDialogRef } from '@angular/material/dialog';
import { MsalService } from '@azure/msal-angular';
import { Observable, Subject, takeUntil, switchMap, timer, startWith } from 'rxjs';
import { PlanEditService } from 'src/app/common/services/plan-edit.service';
import { environment } from 'src/environments/environment';

@Component({
    selector: 'app-session-dialog',
    templateUrl: './session-dialog.component.html',
    styleUrls: ['./session-dialog.component.css'],
    standalone: false
})
export class SessionDialogComponent implements OnInit, OnDestroy {

    constructor(private authService: MsalService, private planEditService: PlanEditService, public dialogRef: MatDialogRef<SessionDialogComponent>) { }

    private unsubscribe$ = new Subject<void>;
    public modalTimer: Observable<number>;
    public resetSessionTimer$ = new Subject();
    public resetModalTimer$ = new Subject();


    modalCount = parseInt(environment.SessionDialogTimeout)/60000;
    modalCountDisplay = parseInt(environment.SessionDialogTimeout)/60000;
    ngOnInit(): void {
        this.modalTimer = this.resetModalTimer$.pipe(
            startWith(void 0),
            switchMap(() => timer(1000, 60000))
        );
        this.modalTimer.pipe(takeUntil(this.unsubscribe$)).subscribe({
            next: (v) => {
                this.modalCountDisplay = this.modalCount - v;
                if (v === 5) {
                    this.planEditService.clear();
                    const account = this.authService.instance.getActiveAccount();
                    this.authService.logoutRedirect({ account: account });
                }
            }
        });
    }

    ngOnDestroy(): void {
        this.unsubscribe$.next();
        this.unsubscribe$.complete();
    }
}
